import useEditorPanelButtonStore from "../store/useEditorPanelButtonStore";
import useEditorStore from "../store/useEditorStore";
import useObjectEditStore from "../store/useObjectEditStore";

export const techPages: string[] = [
  '/contact',
  '/do-not-sell',
  '/privacy-policy',
  '/terms',
];

export const fontFamilyVariants = [
  'Calibri',
  'Courier',
  'Courier New',
  'Verdana',
  'Lato',
  'Helvetica',
  'Open Sans',
  'PT Sans',
  'Roboto',
  'Times New Roman',
  'Arial',
  'Inter',
];

export const fontSizeVariants = [
  '8',
  '10',
  '12',
  '14',
  '16',
  '18',
  '24',
  '32',
  '36',
  '48',
  '60',
  '72',
];

export const fontLineVariants = [
  '1',
  '2',
  '4',
  '6',
  '8',
  '10',
  '12',
];


export const fontColorVariants = [
  'transparent',
  '#FFFFFFFF',
  '#1F1F1FFF',
  '#898989FF',
  '#CBCBCBFF',
  '#FF0000FF',
  '#04E751FF',
  '#018EFBFF',
  '#FF9900FF',
  '#7306FFFF',
];
